// 메인 창 크기(2026-09-28 사용자 요청): 로그인 전 첫 화면은 카드 하나라 작은 창, 로그인 후(기기 목록·관리)는 넓은 창.
// 실제 크기·최소 크기·가운데 유지는 네이티브(Rust `main_window.rs`)가 한다 — 여기서는 배치 이름만 알린다.
import { invoke } from '@tauri-apps/api/core';
import { IS_SHELL } from '../shell';

/** 배치 이름. 🔴 Rust `main_window.rs` 의 `LAYOUT_COMPACT`·`LAYOUT_COMPACT_HOST`·`LAYOUT_FULL` 과 같게. */
export const MAIN_LAYOUT = {
  /** 로그인 전(첫 화면) */
  COMPACT: 'compact',
  /** 로그인 전 · 무인 대상 PC(카드가 접혀 짧다 — 2026-09-29). "다른 PC 를 제어하려면" 을 누르면 COMPACT 로. */
  COMPACT_HOST: 'compact-host',
  /** 로그인 후(기기 목록·관리 화면) */
  FULL: 'full',
} as const;
export type MainLayout = (typeof MAIN_LAYOUT)[keyof typeof MAIN_LAYOUT];

/**
 * 메인 창을 배치에 맞는 크기로. 브라우저 뷰어에서는 아무 일도 하지 않는다(창 크기는 브라우저 몫).
 * 같은 배치로 다시 불러도 네이티브가 무시한다(사용자가 조절한 크기를 되돌리지 않음).
 * `dpr` 을 함께 넘긴다 — 웹 확대 비율이 창 배율과 다른 PC(2026-09-29 x64: 1.19 vs 1.0)에서
 * 네이티브가 그 비만큼 창을 키워 첫 화면 카드가 잘리지 않게 한다(Rust `main_window.rs` 머리 주석).
 */
/**
 * 메인 창 안쪽 높이를 내용에 맞춘다(첫 화면의 창 안 설정 화면, 2026-09-29). **화면 픽셀**로 보낸다 — 웹 확대 비율이
 * 창 배율과 다른 PC 가 있다(Rust `fit_main_window_height`). 설정 화면을 닫으면 `applyMainLayout` 이 원래 크기로 되돌린다.
 *
 * @param cssHeight 원하는 창 안쪽 높이(CSS px)
 */
export function fitMainWindowHeight(cssHeight: number): void {
  if (!IS_SHELL || !(cssHeight > 0)) return;
  const dpr = window.devicePixelRatio || 1;
  void invoke('fit_main_window_height', { height: cssHeight * dpr }).catch(() => {});
}

export function applyMainLayout(layout: MainLayout): void {
  if (!IS_SHELL) return;
  void invoke('set_main_window_layout', { layout, dpr: window.devicePixelRatio || 1 }).catch(() => {
    /* 구버전 껍데기(명령 없음) — 크기만 그대로, 기능엔 지장 없음 */
  });
}
